import { render, staticRenderFns } from "./MoleculeFeedSectionLoading.vue?vue&type=template&id=ce8fdf80"
import script from "./MoleculeFeedSectionLoading.vue?vue&type=script&lang=js"
export * from "./MoleculeFeedSectionLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports